import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingFlatTourBookingContainer } from '../NewbuildingFlatTourBooking';
import { NewbuildingHeaderCallContainer } from '../NewbuildingHeaderCall';
import { NewbuildingHeaderChatButtonContainer } from '../NewbuildingHeaderChatButton';
import { NewbuildingHeaderFavouriteButtonContainer } from '../NewbuildingHeaderFavouriteButton';
import { HeartFavouriteButton } from 'shared/components/HeartFavouriteButton';
import { NewbuildingHeaderServices } from 'shared/components/NewbuildingHeaderServices';
import { getBuilderChatEnabled } from 'shared/selectors/newbuildingHeader';

export const NewbuildingHeaderServicesContainer: React.FC = () => {
  const isBuilderChatEnabled = useSelector(getBuilderChatEnabled);

  return (
    <NewbuildingHeaderServices>
      <NewbuildingHeaderCallContainer />
      {isBuilderChatEnabled && <NewbuildingHeaderChatButtonContainer />}
      <NewbuildingFlatTourBookingContainer isShortened={isBuilderChatEnabled} />
      <NewbuildingHeaderFavouriteButtonContainer button={HeartFavouriteButton} />
    </NewbuildingHeaderServices>
  );
};
